<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/member/updateMember">개인정보수정</router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/mypage/member/outMember">회원탈퇴</router-link></li>
        </ul>
    </div>
    <div class="emphasis">
        <div>
            <p class="bullet03">회원 탈퇴 시 {{ '이대' + this.$store.getters.getHostNm }} 홈페이지에서 온라인 서비스를 이용하실 수 없습니다.</p>
            <p class="bullet03">회원 탈퇴 시 회원정보가 모두 삭제되며 복구할 수 없습니다.</p>
        </div>
        <div class="botton-wrap"><a href="javascript:;" class="main-button c-main" @click="outMember">회원탈퇴</a></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            myInfo: this.$store.state.myInfoStore,
        };
    },
    methods: {
        outMember(){
            if(confirm(`이대${this.$store.getters.getHostNm} 홈페이지에서 탈퇴하시겠습니까?`)){
                this.axios({
                    url: this.api.mypage.myInfoDelete,
                    method: 'post',
                    params: { id: this.myInfo.id }
                })
                    .then(res => {
                        if(res.data.result.code == 'OK') {
							alert("회원탈퇴가 완료되었습니다.");
							this.$store.commit('setStatus', false);
                            location.href="/";
						} else {
                            alert(res.data.result.message);
                            location.reload()
                        }
                    });
            }
        }
    },
    mounted() {
    }
};
</script>

<style scoped></style>